import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createRoute,
  deleteRoute,
  getAllRoutes,
  getRouteById,
  updateRoute,
  updateRouteTrackMap,
} from "./routes.service";

const key = "jeep-rally-routes";

export const useGetAllRoutes = (params = {}, options = {}) => {
  const status = params?.status || "";

  return useQuery({
    queryKey: [key, status],
    queryFn: () => getAllRoutes(params),
    ...options,
  });
};

export const useGetRouteById = (routeId, options = {}) => {
  return useQuery({
    queryKey: [key, routeId],
    queryFn: () => getRouteById(routeId),
    enabled: Boolean(routeId) && options.enabled !== false,
    ...options,
  });
};

export const useCreateRouteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createRoute,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
    },
  });
};

export const useUpdateRouteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ routeId, payload }) => updateRoute(routeId, payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [key] });
      if (variables?.routeId) {
        queryClient.invalidateQueries({
          queryKey: [key, variables.routeId],
        });
      }
    },
  });
};

export const useUpdateRouteTrackMapMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ routeId, formData }) =>
      updateRouteTrackMap(routeId, formData),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [key] });
      if (variables?.routeId) {
        queryClient.invalidateQueries({
          queryKey: [key, variables.routeId],
        });
      }
    },
  });
};

export const useDeleteRouteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ routeId }) => deleteRoute(routeId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
    },
  });
};
